import { useState } from "react";
import type { Identity, ClientRow } from "../types";

type WelcomeBannerProps = {
  identity: Identity;
  client: ClientRow;
};

function isSeen(identityId: string): boolean {
  try {
    return localStorage.getItem(`bgspim_welcome_seen_${identityId}`) === "1";
  } catch {
    return false;
  }
}

function markSeen(identityId: string): void {
  try {
    localStorage.setItem(`bgspim_welcome_seen_${identityId}`, "1");
  } catch {
    // ignore
  }
}

export default function WelcomeBanner({ identity, client }: WelcomeBannerProps) {
  const [dismissed, setDismissed] = useState(() => isSeen(identity.id));

  if (dismissed) return null;
  if (identity.role === "platform_owner") return null;

  const canEdit =
    identity.role === "client_editor" || identity.role === "client_owner";

  function dismiss() {
    markSeen(identity.id);
    setDismissed(true);
  }

  return (
    <div
      className="card card-pad"
      style={{
        background: "rgba(244,196,90,0.06)",
        border: "1px solid rgba(244,196,90,0.20)",
        borderLeft: "3px solid var(--warm-bright)",
        padding: "18px 22px",
        marginBottom: 24,
        display: "flex",
        gap: 20,
        alignItems: "flex-start",
        justifyContent: "space-between",
      }}
      role="region"
      aria-label="Welcome"
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <h4
          className="t-h4"
          style={{ marginBottom: 8, fontSize: 18 }}
        >
          Welcome to {client.name} on BgSPIM.
        </h4>
        {canEdit ? (
          <p
            style={{
              fontSize: 14,
              color: "var(--fg-muted)",
              lineHeight: 1.55,
              maxWidth: 640,
            }}
          >
            This is your catalog. Open any asset to see its details. When you want a
            field or photo updated, submit a change request from the asset and Mark
            will take care of it.
          </p>
        ) : (
          <p
            style={{
              fontSize: 14,
              color: "var(--fg-muted)",
              lineHeight: 1.55,
              maxWidth: 640,
            }}
          >
            You have view access to your catalog — browse anything, open an asset to
            see the detail. Mark can switch you to submit-change access when you're
            ready.
          </p>
        )}
      </div>
      <button
        className="btn btn-primary btn-sm"
        onClick={dismiss}
        style={{ flexShrink: 0 }}
      >
        Got it
      </button>
    </div>
  );
}
